import { coerce, coerceArray } from '@meltwater/coerce';
import { DateRange } from '@meltwater/date-range';
import { InputId } from '@meltwater/inputs';
import { RefinementFilter } from '../refinement-filter/index.js';
import { Filter } from '@meltwater/filters';

/**
 * An object defining what is needed to fire a FilterEvent
 *
 * @param {object} options - See Below
 * @param {DateRange} options.dateRange - The date range of the filter event
 * @param {InputId[]} options.inputs - The array of inputs for the filter event
 * @param {Filter[]} [options.filters=[]] - The array of filters for the filter event
 * @param {RefinementFilter[]} [options.refinementFilters=[]] - The array of refinementFilters for the filter event
 *
 * @property {DateRange} dateRange - The date range of the filter event
 * @property {InputId[]} inputs - The array of inputs for the filter event
 * @property {Filter[]} options.filters - The array of filters for the filter event
 * @property {RefinementFilter[]} options.refinementFilters - The array of refinementFilters for the filter event
 */
export class FilterEvent {
    constructor({
        dateRange,
        inputs,
        filters = [],
        refinementFilters = []
    }) {

        this.dateRange = coerce(dateRange, DateRange,
            `dateRange must be coerceable to DateRange. Provided value: ${JSON.stringify(dateRange)}`
        );
        this.inputs = coerceArray(inputs, InputId,
            `inputs must be coerceable to InputId[]. Provided value: ${inputs}`
        );
        this.filters = coerceArray(filters, Filter,
            `filters must be coerceable to Filter[]. Provided value ${filters}`
        );
        this.refinementFilters = coerceArray(refinementFilters, RefinementFilter,
            `refinementFilters must be coerceable to RefinementFilter[]. Provided value: ${refinementFilters}`
        );

        Object.freeze(this);
    }
}